<template>
    <div>
        <div class="availablerates" @click="toggleShow">
            <div class="availableratesinfo">
                <div class="availableratesprijs darkblue">
                    <font-awesome-icon icon="arrow-down" v-if="isShown" />
                    <font-awesome-icon icon="arrow-right" v-else />
                </div>
                <div>{{ rateName }}</div>
            </div>
        </div>

        <CabinRate
            v-if="isShown"
            v-for="(rate, rateIndex) in flattenedRates"
            :key="rate.id"
            :index="rateIndex"
            :cabinIndex="index"
            :currentRate="rateCode"
            :cabinType="cabin.type"
            :selectedRate="selectedRate"
            :rateIndex="selectedRateIndex"
            :rate="rate"
            :showAll="showAllRates"
        />
    </div>
</template>

<script>
import CabinRate from './CabinRate'

export default {
    name: 'CabinAvailable',
    components: {
        CabinRate,
    },
    data: function() {
        return {
            showAllRates: false,
            isShown: false,
        }
    },
    props: {
        rateCode: String,
        index: Number,
        cabinIndex: Number,
        cabin: Object,
    },
    computed: {
        flattenedRates: function() {
            return this.$store.getters.flattenedRates
        },
        rateName: function() {
            return this.$store.getters.rateName(this.rateCode)
        },
        selectedRate: function() {
            return this.flattenedRates[this.selectedRateIndex]
        },
        selectedRateIndex: function() {
            // I assume this is dont because current index doesn't start at 0
            const newIndex = this.index - 1

            this.$store.commit('changeCabinRate', {
                cabinSetupIndex: newIndex,
                rateSelectIndex: this.$store.state.cabinSetup[newIndex]
                    .rateSelectIndex,
            })

            return this.$store.state.cabinSetup[newIndex].rateSelectIndex
        },
    },
    methods: {
        showAllRate: function() {
            this.showAllRates = !this.showAllRates
        },
        toggleShow: function() {
            this.isShown = !this.isShown
        },
    },
}
</script>

<style scoped lang="scss">
.availablerates {
    padding: 1px;
    background: #def7fe;
    border: 1px solid #f4fcfe;
    display: flex;
    cursor: pointer;
    color: #2178b3;
    div,
    p {
        color: #2178b3;
    }
}

.availablerates .availableratesinfo {
    display: inline-block;
    font-weight: bold;
    padding: 10px;
    line-height: 42px;
    width: calc(100% - 20px);
    float: left;
}

.availablerates .availableratesprijs {
    width: 40px;
    height: 40px;
    text-align: right;
    font-size: 14px;
    float: right;
    margin-right: 0;
    padding-right: 10px;
    display: inline-block;
    font-weight: bold;
}

.availablerates:hover {
    border: 1px solid #37b5d3;
}

@media screen and (min-width: 900px) {
    .availablerates {
        width: calc(100% - 40px);
    }
}
</style>
